import React from 'react';
import { Image, YStack } from 'tamagui';
import { tokens } from 'tamagui-config';

import {
  sunIcon,
  partSunIcon,
  cloudIcon,
  rainIcon,
  blowingSandIcon,
  thunderstormIcon,
} from '../../../assets';
import { GlowCircle } from '../../../components/common/GlowCircle';
import { WeatherIconName } from '../../../types/Weather';

export const weatherIconMap: Record<
  WeatherIconName,
  (color: string, size?: number, hasGlow?: boolean, glowSize?: number) => React.ReactNode
> = {
  sun: (color, size = 24, hasGlow = false, glowSize = size * 1.5) => (
    <YStack position="relative" justifyContent="center" alignItems="center">
      <Image source={{ uri: sunIcon }} width={size} height={size} zIndex={2} />
      {hasGlow && (
        <GlowCircle
          size={glowSize}
          color={tokens.color.weatherOrange}
          style={{ position: 'absolute', zIndex: 1 }}
        />
      )}
    </YStack>
  ),
  wind: (color, size = 24, hasGlow = false, glowSize = size * 1.5) => (
    <YStack position="relative" justifyContent="center" alignItems="center">
      <Image source={{ uri: blowingSandIcon }} width={size} height={size} zIndex={2} />
      {hasGlow && (
        <GlowCircle
          size={glowSize}
          color={tokens.color.weatherBlue}
          style={{ position: 'absolute', zIndex: 1 }}
        />
      )}
    </YStack>
  ),
  cloud: (color, size = 24, hasGlow = false, glowSize = size * 1.5) => (
    <YStack position="relative" justifyContent="center" alignItems="center">
      <Image source={{ uri: cloudIcon }} width={size} height={size} zIndex={2} />
      {hasGlow && (
        <GlowCircle
          size={glowSize}
          color={tokens.color.weatherBlue}
          style={{ position: 'absolute', zIndex: 1 }}
        />
      )}
    </YStack>
  ),
  partlyCloud: (color, size = 24, hasGlow = false, glowSize = size * 1.5) => (
    <YStack position="relative" justifyContent="center" alignItems="center">
      <Image source={{ uri: partSunIcon }} width={size} height={size} zIndex={2} />
      {hasGlow && (
        <GlowCircle
          size={glowSize}
          color={tokens.color.weatherBlue}
          style={{ position: 'absolute', zIndex: 1 }}
        />
      )}
    </YStack>
  ),
  rain: (color, size = 24, hasGlow = false, glowSize = size * 1.5) => (
    <YStack position="relative" justifyContent="center" alignItems="center">
      <Image source={{ uri: rainIcon }} width={size} height={size} zIndex={2} />
      {hasGlow && (
        <GlowCircle
          size={glowSize}
          color={tokens.color.weatherBlue}
          style={{ position: 'absolute', zIndex: 1 }}
        />
      )}
    </YStack>
  ),
  thunderstorm: (color, size = 24, hasGlow = false, glowSize = size * 1.5) => (
    <YStack position="relative" justifyContent="center" alignItems="center">
      <Image source={{ uri: thunderstormIcon }} width={size} height={size} zIndex={2} />
      {hasGlow && (
        <GlowCircle
          size={glowSize}
          color={tokens.color.weatherBlue}
          style={{ position: 'absolute', zIndex: 1 }}
        />
      )}
    </YStack>
  ),
};
